export default "__VITE_ASSET__2c38ef68__"